import { Component, Input, OnInit } from '@angular/core';
import { NgStyle, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-card-status-entregas',
    templateUrl: './card-status-entregas.component.html',
    styleUrls: ['./card-status-entregas.component.css'],
    standalone: true,
    imports: [NgStyle, DecimalPipe]
})
export class CardStatusEntregasComponent {

  @Input() corIndicador: String = '#fff'
  @Input() titulo: String = ''
  @Input() valor: number = 0;
  @Input() dados =  { porcetagem: 0, peso: 0 ,valor : 0}

}
